import * as React from 'react';

const Facebook = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 24 24"
    aria-hidden="true"
  >
    <path
      d="M24 12.07a12 12 0 1 0-13.87 11.86v-8.4H7.08v-3.47h3.05V9.43c0-3 1.8-4.67 4.53-4.67a18 18 0 0 1 2.68.24v3h-1.5a1.73 1.73 0 0 0-1.95 1.87v2.25h3.32l-.53 3.47h-2.8v8.4A12 12 0 0 0 24 12.07z"
      fillRule="evenodd"
    />
  </svg>
);

export default Facebook;
